import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from './WithState.jsx'; 
import { useGlobalState } from '../../App.js';
import { CommandCell } from './MessagesCommandCell.jsx';
import { EditForm } from './EditForm'
import areas from "./Areas.json";
import { toDataSourceRequestString, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const EditCommandCell = (props) => {
    return (
        <td>
            <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => props.enterEdit(props.dataItem)}
            >
                Edit
            </button>
            &nbsp;&nbsp;
            <button
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => props.enterDeleteDialog(props.dataItem)}
            >
                Delete
            </button>
        </td>
        
    );
};



const StatefullGrid = withState(Grid);

export class MessagesTable extends React.Component {



    constructor(props) {
        super(props);
        this.state = {
            dataState: { skip: 0, take: 20 },
            openForm: false,
            openDeleteDialog: false,
            editItem: {
                ID: "",
            },
            tokenData: {}
        };
        this.child = React.createRef();
    }

    MyEditCommandCell = (props) => (
        <EditCommandCell {...props} enterEdit={this.enterEdit} enterDeleteDialog={this.enterDeleteDialog} />
    );

    enterEdit = (item) => {
        this.setState({
            openForm: true,
            editItem: item
        });
    }
    enterDeleteDialog = (item) => {
        this.setState({ editItem: item });
        this.toggleDeleteDialog();
    }

    confirmDelete = () => { 
        var messageId = this.state.editItem.id;
        this.child.current.deleteItem(messageId);
        this.toggleDeleteDialog();
    }

    toggleDeleteDialog = (event) => {
        this.setState({
            openDeleteDialog: !this.state.openDeleteDialog,
        });
    };

    handleSubmit = (event) => {
        event.areaId = event.area.id;
        this.child.current.updateItem(event);
        this.setState({
            openForm: false,
        });     
    }

    handleCancelEdit = () => {
        this.setState({
            openForm: false,
        });
    };

  

    ActiveCell = (props) => {
        const activeVal = props.dataItem.messageActive;
        if (activeVal) {
            return (
                <td
                    style={{
                        backgroundColor: "rgb(55, 180, 0,0.32)",
                    }}
                >
                    True
                </td>
            );
        }
        return (
            <td
                style={{
                    backgroundColor: "rgb(243, 23, 0, 0.32)",
                }}
            >
                False
            </td>
        );
    };

    render() {
        return (
            
            <div>
                <StatefullGrid className="messagesTable" ref={this.child}
                            filterable
                            sortable 
                            pageable
                            pageSize={20}
                            resizable
                            data={this.state.data}               >
                            <GridColumn field="messageName" title="Name" groupable={false} />
                            <GridColumn field="messageWav" title="Wav" groupable={false} />
                            <GridColumn field="messageId" title="Msg Num" groupable={false} />
                            <GridColumn field="area.areaName" title="Area" groupable={false} />
                            <GridColumn field="messageActive" title="Active" groupable={false} cell={this.ActiveCell} />
                            <GridColumn
                                groupable={false}
                                sortable={false}
                                filterable={false}
                                resizable={false}
                                field="_command"
                                title=" "
                                width="180px"
                                cell={this.MyEditCommandCell} />
                        </StatefullGrid>
                        {
                        this.state.openForm && (
                            <EditForm
                                cancelEdit={this.handleCancelEdit}
                                onSubmit={this.handleSubmit}
                                item={this.state.editItem}
                            />
                        )
                }{this.state.openDeleteDialog && <Dialog title={"Please confirm deletion"} onClose={this.toggleDeleteDialog}>
                    <p style={{ margin: "25px", textAlign: "center" }}>Are you sure you want to delete this item?</p>
                    <DialogActionsBar>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={this.toggleDeleteDialog}>No</button>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={this.confirmDelete}>Yes</button>
                    </DialogActionsBar>
                </Dialog>}

            </div>
                  
             );
        
    }

    
} 
 